<template>
    <!--begin::Navbar-->
    <div class="app-navbar flex-shrink-0">
        <!--begin::Search-->
        <div class="app-navbar-item align-items-stretch ms-1 ms-md-4">
            <KTSearch />
        </div>
        <!--end::Search-->
        <!--begin::Activities-->
        <!--<div class="app-navbar-item ms-1 ms-md-4">-->
        <!--begin::Drawer toggle-->
        <!--<div class="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px"
         id="kt_activities_toggle">
        <KTIcon icon-name="messages" icon-class="fs-2" />
    </div>-->
        <!--end::Drawer toggle-->
        <!--</div>-->
        <!--end::Activities-->
        <!--begin::Notifications-->
        <!--<div class="app-navbar-item ms-1 ms-md-4">-->
        <!--begin::Menu- wrapper-->
        <!--<div class="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px"
         data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
         data-kt-menu-attach="parent"
         data-kt-menu-placement="bottom-end"
         id="kt_menu_item_wow">
        <KTIcon icon-name="notification-status" icon-class="fs-2" />
    </div>
    <KTNotificationMenu />-->
        <KTNotificationMenu />
        <!--end::Menu wrapper-->
        <!--</div>-->
        <!--end::Notifications-->
        <!--begin::Chat-->
        <!--<div class="app-navbar-item ms-1 ms-md-4" @click="isOpenListChat= !isOpenListChat">
        <div class="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px position-relative"
             id="kt_drawer_chat_toggle">
            <KTIcon icon-name="message-text-2" icon-class="fs-2" />
            <span class="bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink"></span>
        </div>
    </div>
    <KTListChat v-if="isOpenListChat" @closeListChat="closeListChat()" @openBoxChat="openBoxChat($event)"></KTListChat>-->
        <!--end::Chat-->
        <!--begin::Customize UI-->
        <!--<div class="app-navbar-item ms-1 ms-md-4">-->
        <!--begin::Menu wrapper-->
        <!--<div class="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px position-relative"
         id="kt_app_layout_builder_toggle" title="Tùy biến giao diện">
        <KTIcon icon-name="setting-4" icon-class="fs-2" />
    </div>-->
        <!--end::Menu wrapper-->
        <!--</div>-->
        <!--end::Customize UI-->
        <!--begin::Theme mode-->
        <!--<div class="app-navbar-item ms-1 ms-md-3">-->
        <!--begin::Menu toggle-->
        <!--<a href="#"
       class="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px"
       data-kt-menu-trigger="{default:'click', lg: 'hover'}"
       data-kt-menu-attach="parent"
       data-kt-menu-placement="bottom-end" title="Chủ đề">
        <KTIcon v-if="themeMode === 'light'"
                icon-name="night-day"
                icon-class="fs-2" />
        <KTIcon v-else icon-name="moon" icon-class="fs-2" />
    </a>-->
        <!--begin::Menu toggle-->
        <!--<KTThemeModeSwitcher />
    </div>-->
        <!--end::Theme mode-->
        <!--begin::User menu-->
        <div class="app-navbar-item ms-1 ms-md-4" id="kt_header_user_menu_toggle" v-if="user">
            <!--begin::Menu wrapper-->
            <div class="cursor-pointer symbol symbol-35px"
                 data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
                 data-kt-menu-attach="parent"
                 data-kt-menu-placement="bottom-end">
                <img src="assets/media/auth/no-avatar.jpg"
                     class="rounded-3"
                     alt="user" />
            </div>
            <KTUserMenu />
            <!--end::Menu wrapper-->
        </div>
        <!--end::User menu-->
        <!--begin::Header menu toggle-->
        <div class="app-navbar-item d-lg-none ms-2 me-n2">
            <div class="btn btn-flex btn-icon btn-active-color-primary w-30px h-30px"
                 id="kt_app_header_menu_toggle">
                <KTIcon icon-name="element-4" icon-class="fs-2" />
            </div>
        </div>
        <chat-box v-if="isOpenBoxChat && currentChatGroupId > 0" :currentChatGroupId="currentChatGroupId" @closeChatBox="closeChatBox()"></chat-box>
        <!--end::Header menu toggle-->
    </div>
    <!--end::Navbar-->
</template>

<script lang="ts">
    import { getAssetPath } from "@/core/helpers/assets";
    import { computed, defineComponent } from "vue";
    import KTSearch from "@/layouts/default-layout/components/search/Search.vue";
    import KTNotificationMenu from "@/layouts/default-layout/components/menus/NotificationsMenu.vue";
    import KTUserMenu from "@/layouts/default-layout/components/menus/UserAccountMenu.vue";
    import KTListChat from "@/layouts/default-layout/components/extras/MessengerDrawer.vue";
    //import KTThemeModeSwitcher from "@/layouts/default-layout/components/theme-mode/ThemeModeSwitcher.vue";
    import { ThemeModeComponent } from "@/assets/ts/layout";
    import { useThemeStore } from "@/stores/theme";

    export default defineComponent({
        name: "header-navbar",
        components: {
            KTSearch,
            KTNotificationMenu,
            KTUserMenu,
            KTListChat
            //KTThemeModeSwitcher,
        },
        setup() {
            const isOpenListChat = ref(false);
            const store = useThemeStore();
            const authStore = useAuthStore();
            const user = authStore.user;
            const isOpenBoxChat = ref(false);

            const currentChatGroupId = ref(0);
            const themeMode = computed(() => {
                if (store.mode === "system") {
                    return ThemeModeComponent.getSystemMode();
                }
                return store.mode;
            });
            const closeListChat = () => {
                isOpenListChat.value = false;

            };
            const openBoxChat = (chatGroupId: number) => {
                currentChatGroupId.value = chatGroupId;
                isOpenBoxChat.value = true;
                closeListChat();
            };
            const closeChatBox = () => {
                isOpenBoxChat.value = false;
                currentChatGroupId.value = 0;
            };
            return {
                themeMode,
                getAssetPath,
                user,
                isOpenListChat,
                closeListChat,
                isOpenBoxChat,
                currentChatGroupId,
                openBoxChat,
                closeChatBox
            };
        },
    });
</script>
